import React, { useEffect } from 'react'
import NaveBar from '../composant/NaveHero/NaveBar'
import Footer from '../composant/Footer'
import AboutBanner from '../composant/AboutBanner'
import AboutSection from '../composant/AboutSection'
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2'


const About = () => {
    // Scroll to top on mount
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div>
       <NaveBar />

       
       <AboutSection />
      
       <MainContainerAdhesion2 />
       <Footer />
    </div>
  )
}

export default About
